import * as React from 'react'

import { IProps } from '../ProductProps'
import { isAudioProduct } from '../utils'
import { AudioProduct } from './AudioProduct'
import { StillOrMotionProduct } from './StillOrMotionProduct'

export default (props: IProps): JSX.Element => {
  if (isAudioProduct(props.product)) {
    return <AudioProduct {...props} />
  } else {
    return <StillOrMotionProduct {...props} />
  }
}
